import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import QRCode from 'qrcode.react'
import { Grid, Typography, Divider } from '@mui/material'
import { formatNumber } from 'utils/helpers'

const BaleTag = ({ createdDate, materialName, gross, tare, net, qrCodeValue, notes }) => {
  const { defaultYardUm } = useSelector(state => state.settings)
  const { enablePullApartFeatures } = useSelector(state => state.featureFlags?.variables || {})

  if (enablePullApartFeatures) {
    return (
      <>
        <Divider />
        <Grid container direction="row" spacing={2} pt={2}>
          {/* Left column */}
          <Grid item xs={8}>
            <Grid container direction="column">
              <Grid item>
                <Typography variant="body1">{createdDate}</Typography>
                <Typography variant="h6" sx={{ lineHeight: 1.1 }}>
                  <strong>{materialName}</strong>
                </Typography>
              </Grid>

              <Grid item mt={1}>
                <Grid container spacing={1}>
                  <Grid item xs={4}>
                    <Typography variant="body2">Gross:</Typography>
                    <Typography variant="h6">
                      <strong>{formatNumber(gross)}</strong>
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="body2">Tare:</Typography>
                    <Typography variant="h6">
                      <strong>{formatNumber(tare)}</strong>
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="body2">Net:</Typography>
                    <Typography variant="h6">
                      <strong>{formatNumber(net)}</strong>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              {notes && (
                <Grid item>
                  <Typography variant="caption">Notes: {notes}</Typography>
                </Grid>
              )}
            </Grid>
          </Grid>

          {/* Right column - QR Code */}
          <Grid item xs={4} container justifyContent="center" alignItems="top">
            {qrCodeValue && <QRCode value={qrCodeValue} size={100} />}
          </Grid>
        </Grid>
      </>
    )
  }

  // Original vertical layout
  return (
    <>
      <Divider />

      <Grid container direction="column">
        <Grid item>
          <Typography variant="h6">{createdDate}</Typography>
        </Grid>

        <Grid item mb={2}>
          <Typography lineHeight={1} variant="h6">
            {materialName}
          </Typography>
        </Grid>

        <Divider />

        <Grid mt={1} item container>
          <Grid container justifyContent="space-between">
            <Typography lineHeight={1} mr={2} variant="h6">
              Gross:
            </Typography>
            <Typography lineHeight={1} variant="h6">{`${formatNumber(gross)} ${defaultYardUm}`}</Typography>
          </Grid>

          <Grid container justifyContent="space-between">
            <Typography lineHeight={1} mr={2} variant="h6">
              Tare:
            </Typography>
            <Typography lineHeight={1} variant="h6">{`${formatNumber(tare)} ${defaultYardUm}`}</Typography>
          </Grid>

          <Grid container justifyContent="space-between">
            <Typography lineHeight={1} mr={2} variant="h6">
              Net:
            </Typography>
            <Typography lineHeight={1} variant="h6">{`${formatNumber(net)} ${defaultYardUm}`}</Typography>
          </Grid>
        </Grid>

        <Grid mt={2} item container justifyContent="center">
          {qrCodeValue && <QRCode value={qrCodeValue} />}
        </Grid>
        {notes && (
          <Grid item mt={3}>
            <Typography variant="h7">NOTES</Typography>
            <Typography variant="h6">{notes}</Typography>
          </Grid>
        )}
      </Grid>
    </>
  )
}

BaleTag.propTypes = {
  createdDate: PropTypes.string.isRequired,
  materialName: PropTypes.string.isRequired,
  gross: PropTypes.number.isRequired,
  tare: PropTypes.number.isRequired,
  net: PropTypes.number.isRequired,
  qrCodeValue: PropTypes.string.isRequired,
  notes: PropTypes.string,
}

BaleTag.defaultProps = {
  notes: '',
}

export default BaleTag
